import Vue from 'vue';

const state =
{
    data: {},
};

const actions =
{

    write ({commit}, data) {

        commit('WRITE', data);
    },
    
    updateEntry ({commit}, data) {

        commit('UPDATE_ENTRY', data);
    },
};

const mutations =
{

    WRITE (state, data) {

        if (typeof data.key == 'undefined')
        {
            console.error('Key for temp is missing');
            return false;
        }

        // Remove reactivity from temp object
        state.data[data.key] = JSON.parse(JSON.stringify(data.payload));
    },
    
    UPDATE_ENTRY (state, data) {

        if (typeof data.key == 'undefined' || typeof data.path == 'undefined')
        {
            console.error('Key for temp is missing');
            return false;
        }

        let obj = _.update(state.data[data.key], data.path, () => data.entry);

        // Remove reactivity from temp object
        state.data[data.key] = (typeof obj != 'undefined')? obj : state.data[data.key];
    },
};

export default
{
    namespaced: true,
    state,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/js/vuex/modules/temp.js